import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Minutes'
  }, {
    value: seconds,
    label: 'Seconds'
  }];
  const dark = tone === 'dark';
  return <div className="mt-8 text-center" role="timer" aria-live="off" data-id="element-74" data-mp="3c48r4lqf57hz">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider ${dark ? 'text-gold' : 'text-gum'}`} data-id="element-75" data-mp="3h2k0ywgpri07">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-76" data-mp="371zxro9mw3fc" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-77" data-mp="10dej9n0l2ztn">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-78" data-mp="15a504ck7pzg4" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-79" data-mp="15928g2f2fsz5">
              <span className={`flex h-[68px] w-[72px] items-center justify-center rounded-xl font-serif text-4xl font-black tabular-nums sm:h-20 sm:w-20 sm:text-5xl ${dark ? 'bg-white text-brand-dark' : 'bg-brand-dark text-white'}`} data-id="element-80" data-mp="xzvfz6ww0ry0">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? 'text-white/70' : 'text-muted'}`} data-id="element-81" data-mp="f2aum9tc0bi5">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-black sm:pt-5 ${dark ? 'text-white' : 'text-brand-dark'}`} aria-hidden="true" data-id="element-82" data-mp="k1neclowp2gi">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}